import httpService from '@/services/core/http.service';

/**
 * The TinyPumper incident dashboard (dbo.SensorIncident).
 *
 * The grid is a remote DevExtreme store: paging, sorting and filtering are the server's job, so
 * nothing here ever asks for "all incidents".
 */
class TinyPumperIncidentsService {
    route = 'tiny-pumper-incidents';

    getGridDataSource = (includeClosed = false) =>
        httpService.getDxDataSource(`${this.route}/grid${includeClosed ? '?includeClosed=true' : ''}`);

    totals = () => httpService.get(`${this.route}/totals`);

    /** The coordinator's morning queue: needs you (by client), waiting on someone, and not yours. */
    today = () => httpService.get(`${this.route}/today`);

    /** Open incidents grouped by cause, each group carrying the playbook for who acts and how. */
    triage = () => httpService.get(`${this.route}/triage`);

    getById = id => httpService.get(`${this.route}/${id}`);

    snooze = (id, snooze) => httpService.put(`${this.route}/${id}/snooze`, snooze);

    acknowledge = id => httpService.put(`${this.route}/${id}/acknowledge`, null);

    decommission = sensorId => httpService.put(`${this.route}/sensors/${sensorId}/decommission`, null);

    /** Whether TinyPumper Slack posts and the daily digest may be sent, and who last decided. */
    alerting = () => httpService.get(`${this.route}/alerting`);

    /** Mutes or un-mutes delivery. The incident engine keeps running either way. */
    setAlerting = isAlertingEnabled => httpService.put(`${this.route}/alerting`, { isAlertingEnabled });

    /**
     * The thresholds the last health run actually reasoned with, published by the engine.
     *
     * Read-only by design: these live in the Function's App Settings, so there is no setter here and
     * there cannot be one from this screen.
     */
    policy = () => httpService.get(`${this.route}/policy`);
}

export default new TinyPumperIncidentsService();
